import { useCallback, useEffect, useMemo, useState } from 'react';
import loadScript from './loadScript';

const siteKey = process.env.GATSBY_RECAPTCHA_SITE_KEY;
const captchaScriptID = 'rg-recaptcha-script-async';
let captcha = {};

const useCaptcha = () => {
  const [captchaWidgetID, setCaptchaWidgetID] = useState();
  const [captchaIsReady, setcaptchaIsReady] = useState(false);

  const refreshToken = useCallback(async () => {}, []);

  const initCaptcha = useCallback(() => {
    captcha = window.grecaptcha;

    captcha.ready(async () => {
      const captchaWidgetId = await captcha?.render('rg-recaptcha-demo', {
        sitekey: siteKey,
        size: 'invisible',
        'expired-callback': refreshToken,
      });
      setCaptchaWidgetID(captchaWidgetId);
      setcaptchaIsReady(true);
    });
  }, [refreshToken]);

  const appendScript = useCallback(async () => {
    if (!siteKey) return;
    if (document.getElementById(captchaScriptID) === null && window.grecaptcha === undefined) {
      await loadScript('https://www.google.com/recaptcha/api.js?render=explicit', captchaScriptID);
      initCaptcha();
      return;
    }

    if (window.grecaptcha !== undefined) {
      initCaptcha();
    }
  }, [initCaptcha]);

  useEffect(() => {
    if (!siteKey) {
      window?.console.error('RECAPTCHA SITE KEY is not defined');
    }
    const canInit = siteKey && captchaWidgetID === undefined;
    if (canInit) {
      appendScript();
    }
  }, [appendScript, captchaWidgetID]);

  const fetchCaptchaToken = useCallback(async () => {
    if (captchaWidgetID !== undefined) {
      // eslint-disable-next-line no-return-await
      return await captcha?.execute(captchaWidgetID);
    }
    return undefined;
  }, [captchaWidgetID]);

  return useMemo(
    () => ({
      captchaIsReady,
      fetchCaptchaToken,
    }),
    [captchaIsReady, fetchCaptchaToken]
  );
};

export default useCaptcha;
